<template>
  <div class="collection-list">
    <router-view></router-view>
    <div class="list-header">VoD Export Collections</div>
    <div v-for="(collectionTitle, index) in collectionTitles" :key="index">
        <CollectionListEntry
          v-bind:collectionName=collectionNames[index]
          v-bind:selectedEntry=selectedEntry
          v-bind:collectionTitle=collectionTitle
          v-on:selected-link="onSelectedCollection"
        >
        </CollectionListEntry>
    </div>
  </div>
</template>

<script>
import CollectionListEntry from './CollectionListEntry.vue'
import Details from './Details.vue'

export default {
  name: 'Header',
  props: [
    'collectionNames',
    'collectionTitles',
    'selectedTitle'
  ],
  components: {
    CollectionListEntry,
    Details
  },
  data () {
    return {
      selectedEntry: ''
    }
  },
  watch: {
    selectedTitle: function (val) {
      this.selectedEntry = val
    }
  },
  methods: {
    onSelectedCollection: function (selectedCollectionTitle) {
      let collectionIndex = 0
      let selectedCollectionName = ''

      console.log('Click2')

      console.log('-> title ' + selectedCollectionTitle)

      for (let i = 0; i < this.collectionTitles.length; i = i + 1) {
        /* console.log('  -> comp.: ' + this.collectionTitles[i])
        console.log('  -> with: ' + selectedCollectionTitle) */

        if (this.collectionTitles[i] === selectedCollectionTitle) {
          collectionIndex = i
        }
      }

      selectedCollectionName = this.collectionNames[collectionIndex]
      console.log('-> name ' + selectedCollectionName)
      console.log('Click3')
      this.selectedEntry = selectedCollectionTitle
      console.log('Click4')
      this.$emit('selected-link', selectedCollectionName)
      console.log('Click5')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.collection-list {
  background-color: rgba(255,255,255,0.2);
  width: 300px;
  min-width: 300px;
  margin: 5px;
  margin-left: 0px;
  color: #000;
  overflow-y: scroll;
}
.list-header {
  background-color: rgba(255,255,255,0.2);
  font-size: 12px;
}
.v-paginator {
  font-size: 10px;
  padding: 3px;
  background-color: rgba(255,255,255,0.4);
  // background-color: rgba(0,0,0,0.4);
}

.v-paginator >>> .btn{
  font-size: 10px;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/CollectionList.vue